@if(!homersLayout) {
  <ion-header>
    @if (orderTableItems.length > 0) {
      <ion-toolbar #tableToolBar>
        <ion-buttons slot="end">
          <ion-button class="cancel-btn" fill="solid" (click)="cancel()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title class="cart-title" [ngClass]="{'adjustedTitleFont': settingService.configuration.uIoptions?.homePageOption == 10}">{{ 'Nav.TableOrder' | translate }}</ion-title>
      </ion-toolbar>
    }
  </ion-header>
  <ng-container>
    @if (orderType == 'table') {
      <ion-content #content>
        @if (orderTableItems.length > 0) {
          <ion-content #tableContent class="bg-lightgrey">
            <ion-grid #tableGrid class="top-division">
              @for (item of orderTableItems; track item; let i = $index) {
                <ion-row>
                  <ion-col size="8">
                    <ion-row class="item-name-row">
                      <div class="truncate-text">
                        <span>{{item.quantity}}x &nbsp;</span>
                        <span>{{getItemName(item)}}&nbsp;</span>
                        @if (item.itemDetailCombination) {
                          <ion-icon name="bag-check-outline"></ion-icon>
                        }
                      </div>
                    </ion-row>
                    @if (item.itemDetailCombination) {
                      <ion-row class="option-name">
                        <ion-col>
                          @if (item.itemDetailCombination.size) {
                            {{item.itemDetailCombination.size.translations[translationService.getLanguage()]}}
                          }
                          @if (item.itemDetailCombination.size && item.itemDetailCombination.color) {
                            +
                          }
                          @if (item.itemDetailCombination.color) {
                            {{item.itemDetailCombination.color.translations[translationService.getLanguage()]}}
                          }
                        </ion-col>
                      </ion-row>
                    }
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row >
                        @if (option.quantity != 0) {
                          <ion-col class="option-name">
                            <div class="truncate-text">
                              {{option.quantity}}x &nbsp;{{getOptionName(option.name)}}
                            </div>
                            @if (option.itemDetailCombination) {
                              ({{option.itemDetailCombination.size.translations[translationService.getLanguage()]}} + {{option.itemDetailCombination.color.translations[translationService.getLanguage()]}})
                              <span class="text-button" (click)="editOptionItem(item,item.item,i,oi)">{{'Menu.Modify' | translate }}</span>
                            }
                          </ion-col>
                        }
                      </ion-row>
                    }
                    @if (item.allergies != '') {
                      <ion-row class="allergies">{{'SpecialRequest.Allergies' | translate }}:
                      {{ item.allergies }}</ion-row>
                    }
                    @if (item.note != '') {
                      <ion-row class="specialRequest">
                        {{'SpecialRequest.SpecialRequest' | translate }}:
                        {{ item.note }}
                      </ion-row>
                    }
                    <ion-row>
                      <ion-col class="option-name" style="color: black; margin-top: 6px; display: flex;">
                        <span class="text-button" (click)="editItem(item,item.item,i)">{{'Menu.Modify' | translate }}</span>
                        <ng-container>
                          <ion-icon style="font-size:13pt; margin-left: 15px; margin-right: 6px; margin-top: -2px;" (click)="removeItemQuantity(i,'table')" name="remove-circle-outline"></ion-icon>
                          <span>{{item.quantity}}</span>
                          <ion-icon style="font-size:13pt; margin-left: 6px; margin-top: -2px;" (click)="addItemQuantity(i,'table')" name="add-circle-outline"></ion-icon>
                        </ng-container>
                      </ion-col>
                    </ion-row>
                  </ion-col>
                  <ion-col size="3" style="text-align: right;">
                    @if (!item._hidePrice) {
                      <span class="item-name-row">{{ item.price * item.quantity | currency }}</span>
                    }
                    @if (item._hidePrice) {
                      <span>&nbsp;</span>
                    }
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '22.5px'}"></div>
                    @for (option of item.options; track option) {
                      <ion-row>
                        <!-- Hide if quantity of option is null -->
                        @if (option.quantity != 0 && !option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.price * option.quantity * item.quantity | currency}}</ion-col>
                        }
                        @if (option.quantity != 0 && option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.itemDetailCombination.price * option.quantity | currency}}</ion-col>
                        }
                      </ion-row>
                    }
                  </ion-col>
                  <ion-col size="1" style="text-align: right;">
                    <ion-icon style="font-size:17pt; margin-top: -3px;" (click)="removeItem(i,'table')" name="close-circle-outline"></ion-icon><br>
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '14px'}"></div>
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row style="height: 15px;">
                        @if (option.itemDetailCombination) {
                          <ion-icon style="font-size: 12pt; margin-top: 2px;" name="close-circle-outline" (click)="removeOptionItem(i, oi,'table')"></ion-icon>}<br>
                        </ion-row>
                      }
                    </ion-col>
                </ion-row>
              }
            </ion-grid>
            <div #tableDiv class="bottom-division" style="position: absolute; width: 100%;">
              <store-checkout-total [store]="store" [order]="order" [options]="tableTotalOptions" [orderType]="'table'" ></store-checkout-total>
              <ion-grid style="padding: 0;">
                <ion-row style="padding: 0;">
                  <ion-col style="padding: 0;" >
                    <ion-grid>
                      <ion-row>
                        <ion-col>
                          <ion-item class="total ion-text-center">
                            <ion-label style="text-align:left;">
                              <ion-button class="desktopMenu" (click)="cancel()" fill="clear">{{'General.Menu' | translate}}
                              </ion-button>
                              <ion-icon class="mobileMenu" (click)="cancel()" name="reader-outline"></ion-icon>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </ion-col>
                  @if (store.orderPrepareTimeMin > 0 || store.orderPrepareTimeMax > 0) {
                    <ion-col >
                      <ion-item  class="timeDelay ion-text-center" style="font-size:9pt; border:none;" >
                        <ion-label style="text-align:left; font-size: 9pt;">
                          <ion-button class="ready estimateTime" style="font-size: 8pt; height:27px;color:white;" fill="clear">   {{'General.ReadyFor' | translate}} {{readyTime}}  </ion-button>
                          <ion-button class="smallReady estimateTime" style="font-size: 8pt; height:27px;color:white;"  fill="clear">   {{'General.ShortFormReadyFor' | translate}} {{readyTime}}  </ion-button>
                        </ion-label>
                      </ion-item>
                    </ion-col>
                  }
                  <ion-col >
                    <app-cartsub-modal [store]="store" [subTotal]="tableSubTotal" [orderType]="'table'" [fromDesktop]="fromDesktop"></app-cartsub-modal>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </ion-content>
        }
      </ion-content>
    }

    @if (orderType == 'seat') {
      <ion-content #content>
        @if (orderSeatItems.length > 0) {
          <ion-toolbar #seatToolBar>
            <ion-buttons slot="end">
              <ion-button class="cancel-btn" fill="solid" (click)="cancel()">
                <ion-icon name="close-outline"></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-title class="cart-title" [ngClass]="{'adjustedTitleFont': settingService.configuration.uIoptions?.homePageOption == 10}">{{ 'Nav.SeatOrder' | translate }}</ion-title>
          </ion-toolbar>
        }
        @if (orderSeatItems.length > 0) {
          <ion-content #seatContent class="bg-lightgrey">
            <ion-grid #seatGrid class="top-division">
              @for (item of orderSeatItems; track item; let i = $index) {
                <ion-row>
                  <ion-col size="8">
                    <ion-row class="item-name-row">
                      <div class="truncate-text">
                        <span>{{item.quantity}}x &nbsp;</span>
                        <span>{{getItemName(item)}}&nbsp;</span>
                        @if (item.itemDetailCombination) {
                          <ion-icon name="bag-check-outline"></ion-icon>
                        }
                      </div>
                    </ion-row>
                    @if (item.itemDetailCombination) {
                      <ion-row class="option-name">
                        <ion-col>
                          @if (item.itemDetailCombination.size) {
                            {{item.itemDetailCombination.size.translations[translationService.getLanguage()]}}
                          }
                          @if (item.itemDetailCombination.size && item.itemDetailCombination.color) {
                            +
                          }
                          @if (item.itemDetailCombination.color) {
                            {{item.itemDetailCombination.color.translations[translationService.getLanguage()]}}
                          }
                        </ion-col>
                      </ion-row>
                    }
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row >
                        @if (option.quantity != 0) {
                          <ion-col class="option-name">
                            <div class="truncate-text">
                              {{option.quantity}}x &nbsp;{{getOptionName(option.name)}}
                            </div>
                            @if (option.itemDetailCombination) {
                              ({{option.itemDetailCombination.size.translations[translationService.getLanguage()]}} + {{option.itemDetailCombination.color.translations[translationService.getLanguage()]}})
                              <span class="text-button" (click)="editOptionItem(item,item.item,i,oi)">{{'Menu.Modify' | translate }}</span>
                            }
                          </ion-col>
                        }
                      </ion-row>
                    }
                    @if (item.allergies != '') {
                      <ion-row class="allergies">{{'SpecialRequest.Allergies' | translate }}:
                      {{ item.allergies }}</ion-row>
                    }
                    @if (item.note != '') {
                      <ion-row class="specialRequest">
                        {{'SpecialRequest.SpecialRequest' | translate }}:
                        {{ item.note }}
                      </ion-row>
                    }
                    <ion-row>
                      <ion-col class="option-name" style="color: black; margin-top: 6px; display: flex;">
                        <span class="text-button" (click)="editItem(item,item.item,i)">{{'Menu.Modify' | translate }}</span>
                        <ng-container>
                          <ion-icon style="font-size:13pt; margin-left: 15px; margin-right: 6px; margin-top: -2px;" (click)="removeItemQuantity(i,'seat')" name="remove-circle-outline"></ion-icon>
                          <span>{{item.quantity}}</span>
                          <ion-icon style="font-size:13pt; margin-left: 6px; margin-top: -2px;" (click)="addItemQuantity(i,'seat')" name="add-circle-outline"></ion-icon>
                        </ng-container>
                      </ion-col>
                    </ion-row>
                    @if (i + 1 == orderSeatItems.length && this.settingService.configuration.minPickupAmount > seatSubTotal) {
                      <ion-row  style="color: red; margin-top: 10px;">
                        {{ 'Store.minDeliveryAmount' | translate}}  {{ this.settingService.configuration.minPickupAmount | currency}}
                      </ion-row>
                    }
                    @if (i + 1 == orderSeatItems.length && this.settingService.configuration.maxPickupAmount < seatSubTotal && this.settingService.configuration.maxPickupAmount > 0) {
                      <ion-row  style="color: red; margin-top: 10px;">
                        {{ 'Store.maxDeliveryAmount' | translate}}  {{ this.settingService.configuration.maxPickupAmount | currency}}
                      </ion-row>
                    }
                  </ion-col>
                  <ion-col size="3" style="text-align: right;">
                    @if (!item._hidePrice) {
                      <span class="item-name-row">{{ item.price * item.quantity | currency }}</span>
                    }
                    @if (item._hidePrice) {
                      <span>&nbsp;</span>
                    }
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '22.5px'}"></div>
                    @for (option of item.options; track option) {
                      <ion-row>
                        @if (option.quantity != 0 && !option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.price * option.quantity * item.quantity | currency}}</ion-col>
                        }
                        @if (option.quantity != 0 && option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.itemDetailCombination.price * option.quantity | currency}}</ion-col>
                        }
                      </ion-row>
                    }
                  </ion-col>
                  <ion-col size="1" style="text-align: right;">
                    <ion-icon style="font-size:17pt; margin-top: -3px;" (click)="removeItem(i,'seat')" name="close-circle-outline"></ion-icon><br>
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '14px'}"></div>
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row style="height: 15px;">
                        @if (option.itemDetailCombination) {
                          <ion-icon style="font-size: 12pt; margin-top: 2px;" name="close-circle-outline" (click)="removeOptionItem(i, oi,'seat')"></ion-icon>
                        }
                        <br>
                      </ion-row>
                    }
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
            <div #seatDiv class="bottom-division" style="position: absolute; width: 100%;">
              <store-checkout-total [store]="store" [order]="order" [options]="seatTotalOptions" [orderType]="'seat'" ></store-checkout-total>
              <div class="checkout-division">
                <nav class="checkout-bar">
                  <ul class="navbar-items">
                    <li class="itemBarPlacement">
                      <ion-icon (click)="cancel()" class="checkoutImg" name="cart-outline"></ion-icon>
                    </li>
                    <li class="itemBarPlacement">
                      <p class="textLayout">{{'General.ReadyFor' | translate}} {{readyTime}}</p>
                    </li>
                    <li class="itemBarPlacement">
                      <app-cartsub-modal class="checkout-btn" [store]="store" [subTotal]="seatSubTotal" [orderType]="'seat'" [fromDesktop]="fromDesktop"></app-cartsub-modal>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </ion-content>
        }
      </ion-content>
    }

    @if (orderType != 'table' && orderType != 'seat') {
      <ion-content #content>
        @if (orderPickupItems.length > 0) {
          <ion-toolbar #pickupToolBar>
            <ion-buttons slot="end">
              <ion-button class="cancel-btn" [ngClass]="{'multiple-orders-cancel-btn': multipleOrders == true}" fill="solid" (click)="cancel()">
                <ion-icon name="close-outline"></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-title class="cart-title" [ngClass]="{'adjustedTitleFont': settingService.configuration.uIoptions?.homePageOption == 10}">{{ 'Nav.PickupCart' | translate }}</ion-title>
          </ion-toolbar>
        }
        @if (orderPickupItems.length > 0) {
          <ion-content #pickupContent class="bg-lightgrey">
            <ion-grid [ngClass]="{'top-division': multipleOrders != true}" #pickupGrid>
              @for (item of orderPickupItems; track item; let i = $index) {
                <ion-row>
                  <ion-col size="8">
                    <ion-row class="item-name-row">
                      <div class="truncate-text">
                        <span>{{item.quantity}}x &nbsp;</span>
                        <span>{{getItemName(item)}}&nbsp;</span>
                        @if (item.itemDetailCombination) {
                          <ion-icon name="bag-check-outline"></ion-icon>
                        }
                      </div>
                    </ion-row>
                    @if (item.itemDetailCombination) {
                      <ion-row class="option-name">
                        <ion-col>
                          @if (item.itemDetailCombination.size) {
                            {{item.itemDetailCombination.size.translations[translationService.getLanguage()]}}
                          }
                          @if (item.itemDetailCombination.size && item.itemDetailCombination.color) {
                            +
                          }
                          @if (item.itemDetailCombination.color) {
                            {{item.itemDetailCombination.color.translations[translationService.getLanguage()]}}
                          }
                        </ion-col>
                      </ion-row>
                    }
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row >
                        @if (option.quantity != 0) {
                          <ion-col class="option-name">
                            <div class="truncate-text">
                              {{option.quantity}}x &nbsp;{{getOptionName(option.name)}}
                            </div>
                            @if (option.itemDetailCombination) {
                              ({{option.itemDetailCombination.size.translations[translationService.getLanguage()]}} + {{option.itemDetailCombination.color.translations[translationService.getLanguage()]}})
                              <span class="text-button" (click)="editOptionItem(item,item.item,i,oi)">{{'Menu.Modify' | translate }}</span>
                            }
                          </ion-col>
                        }
                      </ion-row>
                    }
                    @if (item.allergies != '') {
                      <ion-row class="allergies">{{'SpecialRequest.Allergies' | translate }}:
                      {{ item.allergies }}</ion-row>
                    }
                    @if (item.note != '') {
                      <ion-row class="specialRequest">
                        {{'SpecialRequest.SpecialRequest' | translate }}:
                        {{ item.note }}
                      </ion-row>
                    }
                    <ion-row>
                      <ion-col class="option-name" style="color: black; margin-top: 6px; display: flex;">
                        <span class="text-button" (click)="editItem(item,item.item,i)">{{'Menu.Modify' | translate }}</span>
                        <ng-container>
                          <ion-icon style="font-size:13pt; margin-left: 15px; margin-right: 6px; margin-top: -2px;" (click)="removeItemQuantity(i,'pickup')" name="remove-circle-outline"></ion-icon>
                          <span>{{item.quantity}}</span>
                          <ion-icon style="font-size:13pt; margin-left: 6px; margin-top: -2px;" (click)="addItemQuantity(i,'pickup')" name="add-circle-outline"></ion-icon>
                        </ng-container>
                      </ion-col>
                    </ion-row>
                    <!-- added a warning for default amount -->
                    @if (i + 1 == orderPickupItems.length && this.settingService.configuration.minPickupAmount > pickupSubTotal) {
                      <ion-row  style="color: red; margin-top: 10px;">
                        {{ 'Store.minDeliveryAmount' | translate}}  {{ this.settingService.configuration.minPickupAmount | currency}}
                      </ion-row>
                    }
                    @if (i + 1 == orderPickupItems.length && this.settingService.configuration.maxPickupAmount < pickupSubTotal && this.settingService.configuration.maxPickupAmount > 0) {
                      <ion-row  style="color: red; margin-top: 10px;">
                        {{ 'Store.maxDeliveryAmount' | translate}}  {{ this.settingService.configuration.maxPickupAmount | currency}}
                      </ion-row>
                    }
                  </ion-col>
                  <ion-col size="3" style="text-align: right;">
                    @if (!item._hidePrice) {
                      <span class="item-name-row">{{ item.price * item.quantity | currency }}</span>
                    }
                    @if (item._hidePrice) {
                      <span>&nbsp;</span>
                    }
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '22.5px'}"></div>
                    @for (option of item.options; track option) {
                      <ion-row>
                        <!-- Hide if quantity of option is null -->
                        @if (option.quantity != 0 && !option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.price * option.quantity * item.quantity | currency}}</ion-col>
                        }
                        @if (option.quantity != 0 && option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.itemDetailCombination.price * option.quantity | currency}}</ion-col>
                        }
                      </ion-row>
                    }
                  </ion-col>
                  <ion-col size="1" style="text-align: right;">
                    <ion-icon style="font-size:17pt; margin-top: -3px;" (click)="removeItem(i,'pickup')" name="close-circle-outline"></ion-icon><br>
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '14px'}"></div>
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row style="height: 15px;">
                        @if (option.itemDetailCombination) {
                          <ion-icon style="font-size: 12pt; margin-top: 2px;" name="close-circle-outline" (click)="removeOptionItem(i, oi,'pickup')"></ion-icon>
                        }
                        <br>
                      </ion-row>
                    }
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
            <div #pickupDiv class="bottom-division"  [ngClass]="{'multiple-orders-bottom': multipleOrders == true}" style="position: absolute; width: 100%;">
              <store-checkout-total [store]="store" [order]="order" [options]="pickupTotalOptions" [orderType]="'pickup'" ></store-checkout-total>
              <div class="checkout-division">
                <nav class="checkout-bar">
                  <ul class="navbar-items">
                    <li class="itemBarPlacement">
                      <ion-icon (click)="cancel()" class="checkoutImg" name="cart-outline"></ion-icon>
                    </li>
                    <li class="itemBarPlacement">
                      <p class="textLayout">{{'General.ReadyFor' | translate}} {{readyTime}}</p>
                    </li>
                    <li class="itemBarPlacement">
                      <app-cartsub-modal class="checkout-btn" [store]="store" [subTotal]="pickupSubTotal" [orderType]="'pickup'" [fromDesktop]="fromDesktop"></app-cartsub-modal>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </ion-content>
        }
        @if (orderDeliveryItems.length > 0) {
          <ion-toolbar #deliveryToolBar>
            <ion-buttons slot="end">
              <ion-button class="cancel-btn" [ngClass]="{'multiple-orders-cancel-btn': multipleOrders == true}" fill="solid" (click)="cancel()">
                <ion-icon name="close-outline"></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-title class="cart-title" [ngClass]="{'adjustedTitleFont': settingService.configuration.uIoptions?.homePageOption == 10}">{{ 'Nav.DeliveryCart' | translate }}</ion-title>
          </ion-toolbar>
        }
        @if (orderDeliveryItems.length > 0) {
          <ion-content #deliveryContent class="bg-lightgrey">
            <ion-grid [ngClass]="{'top-division': multipleOrders != true}" #deliveryGrid>
              @for (item of orderDeliveryItems; track item; let i = $index) {
                <ion-row>
                  <ion-col size="8">
                    <ion-row class="item-name-row">
                      <div class="truncate-text">
                        <span>{{item.quantity}}x &nbsp;</span>
                        <span>{{getItemName(item)}}&nbsp;</span>
                        @if (item.itemDetailCombination) {
                          <ion-icon name="bag-check-outline"></ion-icon>
                        }
                      </div>
                    </ion-row>
                    @if (item.itemDetailCombination) {
                      <ion-row class="option-name">
                        <ion-col>
                          @if (item.itemDetailCombination.size) {
                            {{item.itemDetailCombination.size.translations[translationService.getLanguage()]}}
                          }
                          @if (item.itemDetailCombination.size && item.itemDetailCombination.color) {
                            +
                          }
                          @if (item.itemDetailCombination.color) {
                            {{item.itemDetailCombination.color.translations[translationService.getLanguage()]}}
                          }
                        </ion-col>
                      </ion-row>
                    }
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row >
                        @if (option.quantity != 0) {
                          <ion-col class="option-name">
                            <div class="truncate-text">
                              {{option.quantity}}x &nbsp;{{getOptionName(option.name)}}
                            </div>
                            @if (option.itemDetailCombination) {
                              ({{option.itemDetailCombination.size.translations[translationService.getLanguage()]}} + {{option.itemDetailCombination.color.translations[translationService.getLanguage()]}})
                              <span class="text-button" (click)="editOptionItem(item,item.item,i,oi)">{{'Menu.Modify' | translate }}</span>
                            }
                          </ion-col>
                        }
                      </ion-row>
                    }
                    @if (item.allergies != '') {
                      <ion-row class="allergies">{{'SpecialRequest.Allergies' | translate }}:
                      {{ item.allergies }}</ion-row>
                    }
                    @if (item.note != '') {
                      <ion-row class="specialRequest">
                        {{'SpecialRequest.SpecialRequest' | translate }}:
                        {{ item.note }}
                      </ion-row>
                    }
                    <ion-row>
                      <ion-col class="option-name" style="color: black; margin-top: 6px; display: flex;">
                        <span class="text-button" (click)="editItem(item,item.item,i)">{{'Menu.Modify' | translate }}</span>
                        <ng-container>
                          <ion-icon style="font-size:13pt; margin-left: 15px; margin-right: 6px; margin-top: -2px;" (click)="removeItemQuantity(i,'delivery')" name="remove-circle-outline"></ion-icon>
                          <span>{{item.quantity}}</span>
                          <ion-icon style="font-size:13pt; margin-left: 6px; margin-top: -2px;" (click)="addItemQuantity(i,'delivery')" name="add-circle-outline"></ion-icon>
                        </ng-container>
                      </ion-col>
                    </ion-row>
                    @if (i + 1 == orderDeliveryItems.length && store.deliveryMinAmount > deliverySubTotal) {
                      <ion-row  style="color: red; margin-top: 10px;">
                        {{ 'Store.minDeliveryAmount' | translate}}  {{ store.deliveryMinAmount | currency}}
                      </ion-row>
                    }
                    @if (i + 1 == orderDeliveryItems.length && store.deliveryMaxAmount < deliverySubTotal && store.deliveryMaxAmount > 0) {
                      <ion-row  style="color: red; margin-top: 10px;">
                        {{ 'Store.maxDeliveryAmount' | translate}}  {{ store.deliveryMaxAmount | currency}}
                      </ion-row>
                    }
                  </ion-col>
                  <ion-col size="3" style="text-align: right;">
                    @if (!item._hidePrice) {
                      <span class="item-name-row">{{ item.price * item.quantity | currency }}</span>
                    }
                    @if (item._hidePrice) {
                      <span>&nbsp;</span>
                    }
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '22.5px'}"></div>
                    @for (option of item.options; track option) {
                      <ion-row>
                        @if (option.quantity != 0 && !option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.price * option.quantity * item.quantity | currency}}</ion-col>
                        }
                        @if (option.quantity != 0 && option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.itemDetailCombination.price * option.quantity | currency}}</ion-col>
                        }
                      </ion-row>
                    }
                  </ion-col>
                  <ion-col size="1" style="text-align: right;">
                    <ion-icon style="font-size:17pt; margin-top: -3px;" (click)="removeItem(i,'delivery')" name="close-circle-outline"></ion-icon><br>
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '14px'}"></div>
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row style="height: 15px;">
                        @if (option.itemDetailCombination) {
                          <ion-icon style="font-size: 12pt; margin-top: 2px;" name="close-circle-outline" (click)="removeOptionItem(i, oi, 'delivery')"></ion-icon>
                        }
                        <br>
                      </ion-row>
                    }
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
            <div #deliveryDiv class="bottom-division" [ngClass]="{'multiple-orders-bottom': multipleOrders == true}" style="position: absolute; width: 100%;">
              <store-checkout-total [store]="store" [order]="order" [options]="deliveryTotalOptions" [orderType]="'delivery'"></store-checkout-total>
              <ion-grid style="padding: 0;">
                <ion-row style="padding: 0;">
                  <ion-col style="padding: 0;" >
                    <ion-grid>
                      <ion-row>
                        <ion-col>
                          <ion-item class="total ion-text-center">
                            <ion-label style="text-align:left;">
                              <ion-button class="desktopMenu" (click)="cancel()" fill="clear">{{'General.Menu' | translate}}
                              </ion-button>
                              <ion-icon class="mobileMenu" (click)="cancel()" name="reader-outline"></ion-icon>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </ion-col>
                  @if (store.orderPrepareTimeMin > 0 || store.orderPrepareTimeMax > 0) {
                    <ion-col >
                      <ion-item  class="timeDelay ion-text-center" style="font-size:9pt; border:none;" >
                        <ion-label style="text-align:left; font-size: 9pt;">
                          <ion-button class="ready estimateTime" style="font-size: 8pt; height:27px;color:white;" fill="clear">   {{'General.ReadyFor' | translate}} {{readyTime}}  </ion-button>
                          <ion-button class="smallReady estimateTime" style="font-size: 8pt; height:27px;color:white;"  fill="clear">   {{'General.ShortFormReadyFor' | translate}} {{readyTime}}  </ion-button>
                        </ion-label>
                      </ion-item>
                    </ion-col>
                  }
                  <ion-col >
                    <app-cartsub-modal [store]="store" [subTotal]="deliverySubTotal" [orderType]="'delivery'" [fromDesktop]="fromDesktop"></app-cartsub-modal>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </ion-content>
        }
        @if (orderShippingItems.length > 0) {
          <ion-toolbar #shippingToolBar>
            <ion-buttons slot="end">
              <ion-button class="cancel-btn" [ngClass]="{'multiple-orders-cancel-btn': multipleOrders == true}" fill="solid" (click)="cancel()">
                <ion-icon name="close-outline"></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-title class="cart-title" [ngClass]="{'adjustedTitleFont': settingService.configuration.uIoptions?.homePageOption == 10}">{{ 'Nav.ShippingCart' | translate }}</ion-title>
          </ion-toolbar>
        }
        @if (orderShippingItems.length > 0) {
          <ion-content #shippingContent class="bg-lightgrey">
            <ion-grid [ngClass]="{'top-division': multipleOrders != true}" #shippingGrid>
              @for (item of orderShippingItems; track item; let i = $index) {
                <ion-row>
                  <ion-col size="8">
                    <ion-row class="item-name-row">
                      <div class="truncate-text">
                        <span>{{item.quantity}}x &nbsp;</span>
                        <span>{{getItemName(item)}}&nbsp;</span>
                        @if (item.itemDetailCombination) {
                          <ion-icon name="bag-check-outline"></ion-icon>
                        }
                      </div>
                    </ion-row>
                    @if (item.itemDetailCombination) {
                      <ion-row class="option-name">
                        <ion-col>
                          @if (item.itemDetailCombination.size) {
                            {{item.itemDetailCombination.size.translations[translationService.getLanguage()]}}
                          }
                          @if (item.itemDetailCombination.size && item.itemDetailCombination.color) {
                            +
                          }
                          @if (item.itemDetailCombination.color) {
                            {{item.itemDetailCombination.color.translations[translationService.getLanguage()]}}
                          }
                        </ion-col>
                      </ion-row>
                    }
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row >
                        @if (option.quantity != 0) {
                          <ion-col class="option-name">
                            <div class="truncate-text">
                              {{option.quantity}}x &nbsp;{{getOptionName(option.name)}}
                            </div>
                            @if (option.itemDetailCombination) {
                              ({{option.itemDetailCombination.size.translations[translationService.getLanguage()]}}+{{option.itemDetailCombination.color.translations[translationService.getLanguage()]}})
                              <span class="text-button" (click)="editOptionItem(item,item.item,i,oi)">{{'Menu.Modify' | translate }}</span>
                            }
                          </ion-col>
                        }
                      </ion-row>
                    }
                    @if (item.allergies != '') {
                      <ion-row class="allergies">{{'SpecialRequest.Allergies' | translate }}:
                      {{ item.allergies }}</ion-row>
                    }
                    @if (item.note != '') {
                      <ion-row class="specialRequest">
                        {{'SpecialRequest.SpecialRequest' | translate }}:
                        {{ item.note }}
                      </ion-row>
                    }
                    <ion-row>
                      <ion-col class="option-name" style="color: black; margin-top: 6px; display: flex;">
                        <span class="text-button" (click)="editItem(item, item.item, i)">{{'Menu.Modify' | translate }}</span>
                        <ng-container>
                          <ion-icon style="font-size:13pt; margin-left: 15px; margin-right: 6px; margin-top: -2px;" (click)="removeItemQuantity(i,'shipping')" name="remove-circle-outline"></ion-icon>
                          <span>{{item.quantity}}</span>
                          <ion-icon style="font-size:13pt; margin-left: 6px; margin-top: -2px;" (click)="addItemQuantity(i,'shipping')" name="add-circle-outline"></ion-icon>
                        </ng-container>
                      </ion-col>
                    </ion-row>
                    @if (i + 1 == orderShippingItems.length && store.shippingMinAmount > shippingSubTotal) {
                      <ion-row  style="color: red; margin-top: 10px;">
                        {{ 'Store.minShippingAmount' | translate}}  {{ store.shippingMinAmount | currency}}
                      </ion-row>
                    }
                    @if (i + 1 == orderShippingItems.length && store.shippingMaxAmount < shippingSubTotal && store.shippingMaxAmount > 0) {
                      <ion-row  style="color: red; margin-top: 10px;">
                        {{ 'Store.maxShippingAmount' | translate}}  {{ store.shippingMaxAmount | currency}}
                      </ion-row>
                    }
                  </ion-col>
                  <ion-col size="3" style="text-align: right;">
                    @if (!item._hidePrice) {
                      <span class="item-name-row">{{ item.price * item.quantity | currency }}</span>
                    }
                    @if (item._hidePrice) {
                      <span>&nbsp;</span>
                    }
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '22.5px'}"></div>
                    @for (option of item.options; track option) {
                      <ion-row>
                        @if (option.quantity != 0 && !option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.price * option.quantity * item.quantity | currency}}</ion-col>
                        }
                        @if (option.quantity != 0 && option.itemDetailCombination) {
                          <ion-col class="option-price">+{{option.itemDetailCombination.price * option.quantity | currency}}</ion-col>
                        }
                      </ion-row>
                    }
                  </ion-col>
                  <ion-col size="1" style="text-align: right;">
                    <ion-icon style="font-size:17pt; margin-top: -3px;" (click)="removeItem(i,'shipping')" name="close-circle-outline"></ion-icon><br>
                    <div [ngStyle]="item.itemDetailCombination && {'margin-top': '14px'}"></div>
                    @for (option of item.options; track option; let oi = $index) {
                      <ion-row style="height: 15px;">
                        @if (option.itemDetailCombination) {
                          <ion-icon style="font-size: 12pt; margin-top: -2px;" name="close-circle-outline" (click)="removeOptionItem(i, oi, 'shipping')"></ion-icon>
                        }
                        <br>
                      </ion-row>
                    }
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
            <div #shippingDiv class="bottom-division" [ngClass]="{'multiple-orders-bottom': multipleOrders == true}" style="position: absolute; width: 100%;">
              <store-checkout-total [store]="store" [order]="order" [options]="shippingTotalOptions" [orderType]="'shipping'"></store-checkout-total>
              <ion-grid style="padding: 0;">
                <ion-row style="padding: 0;">
                  <ion-col style="padding: 0;" >
                    <ion-grid>
                      <ion-row>
                        <ion-col>
                          <ion-item class="total ion-text-center">
                            <ion-label style="text-align:left;">
                              <ion-button class="desktopMenu" (click)="cancel()" fill="clear">{{'General.Menu' | translate}}
                              </ion-button>
                              <ion-icon class="mobileMenu" (click)="cancel()" name="reader-outline"></ion-icon>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </ion-col>
                  @if (store.orderPrepareTimeMin > 0 || store.orderPrepareTimeMax > 0) {
                    <ion-col >
                      <ion-item  class="timeDelay ion-text-center" style="font-size:9pt; border:none;" >
                        <ion-label style="text-align:left; font-size: 9pt;">
                          <ion-button class="ready estimateTime" style="font-size: 8pt; height:27px;color:white;" fill="clear">   {{'General.ReadyFor' | translate}} {{readyTime}}  </ion-button>
                          <ion-button class="smallReady estimateTime" style="font-size: 8pt; height:27px;color:white;"  fill="clear">   {{'General.ShortFormReadyFor' | translate}} {{readyTime}}  </ion-button>
                        </ion-label>
                      </ion-item>
                    </ion-col>
                  }
                  <ion-col >
                    <app-cartsub-modal [store]="store" [subTotal]="shippingSubTotal" [orderType]="'shipping'" [fromDesktop]="fromDesktop"></app-cartsub-modal>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </ion-content>
        }
      </ion-content>
    }
  </ng-container>
} @else {

  @if (orderType != 'table' && orderType != 'seat') {
    <ion-content #content>
      @if (orderPickupItems.length > 0) {
        <ion-toolbar #pickupToolBar [ngClass]="{'toolbar-homers': homersLayout}" >
          <ion-buttons slot="end">
            <ion-button class="cancel-btn" [ngClass]="{'multiple-orders-cancel-btn': multipleOrders == true, 'paytoneFont': homersLayout, 'cancel-btn-homers': homersLayout}" fill="solid" (click)="cancel()">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title class="cart-title" [ngClass]="{'paytoneFont': homersLayout, 'adjustedTitleFont': homersLayout}">{{ 'Commande à ramasser' | translate }}</ion-title>
        </ion-toolbar>
      }


      @if (orderPickupItems.length > 0) {
        <ion-content #pickupContent class="bg-lightgrey" [ngClass]="{'main-content-homers': homersLayout}">

          <div class="orderFrame">
            <div class="orderPanel">
              <div class="timeContainer">
                <div class="estimatedTime" [ngClass]="{'poppinsNormalFont': homersLayout}">
                  {{'Heure estimée : '}} {{readyTime}}
                </div>
              </div>
              <div class="orderDetailsContainer">
                <div class="locationContainer">
                  <div class="titleContainer" [ngClass]="{'paytoneFont': homersLayout}">
                    {{store.displayName}}
                  </div>
                  <div class="addressContainer" [ngClass]="{'poppinsNormalFont': homersLayout}">
                    {{store.address?.streetNumber}} {{store.address?.street}}, {{store.address?.city}}, {{store.address?.province}}, {{store.address?.postalCode}}
                  </div>

                  <div class="itemListContainer">
                    @for (item of orderPickupItems; track item; let i = $index) {
                      <div class="itemContainer">
                        <div class="itemImageContainer">
                          @if(item._itemImage) {
                            <img class="itemImageResize" [src]="getImageSrc(item)" alt="">
                          }
                        </div>
                        <div class="itemDetailsContainer">
                          <div class="itemDetails">
                            <div class="itemTitle" [ngClass]="{'poppinsNormalFont': homersLayout}">
                              {{ getItemName(item) }}
                            </div>
                            <div class="itemDescription" [ngClass]="{'poppinsNormalFont': homersLayout}" [innerHTML]="item.description?.translations[this.translationService.getLanguage()]"></div>
                            
                            <!--start of the options-->
                            <div class="optionsList">
                              @for (option of item.options; track option; let oi = $index) {
                                <div class="optionContainer">
                                  <div class="optionQuantity" [ngClass]="{'poppinsNormalFont': homersLayout}">
                                    {{option.quantity}}x &nbsp;{{getOptionName(option.name)}}  @if(option.price * option.quantity * item.quantity > 0) { <span>+{{option.price * option.quantity * item.quantity | currency}}</span> }
                                  </div>
                                </div>
                              }
                              
                            </div>
                            
                            <button class="modificationBtn" [ngClass]="{'poppinsNormalFont': homersLayout}" (click)="editItemV2(item, item.item, i)">{{'Menu.Modify' | translate}}</button>
                          </div>
                          <div class="itemPrice">
                            <div class="price" [ngClass]="{'paytoneFont': homersLayout}">{{item.price * item.quantity | currency}}</div>
                            <div class="itemCount">
                              <div class="arrowOrBin">
                                @if(item.quantity > 1) {
                                  <ion-icon class="chevron" (click)="removeItemQuantity(i,'pickup')" size="medium" slot="start" [ios]="'chevron-back-outline'" [md]="'chevron-back-outline'"></ion-icon>
                                } @else {
                                  <ion-icon class="chevron" (click)="removeItem(i,'pickup')" size="small" slot="start" [ios]="'trash-outline'" [md]="'trash-sharp'" ></ion-icon>
                                }
                              </div>
                              <div class="count" [ngClass]="{'paytoneFont': homersLayout}">
                                {{ item.quantity }}
                              </div>
                              <div class="arrowRight">
                                <ion-icon class="chevron chevron-Rotate" (click)="addItemQuantity(i,'pickup')" size="medium" slot="start" [ios]="'chevron-back-outline'" [md]="'chevron-back-outline'"></ion-icon>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                    }
                    

                    

                  </div>
                </div>
              </div>

            </div>
          </div>

          <div #pickupDiv class="bottom-division"  [ngClass]="{'multiple-orders-bottom': multipleOrders == true, 'homers-Bottom-Division': homersLayout}" style="position: absolute; width: 100%;">
            <store-checkout-total [store]="store" [order]="order" [options]="pickupTotalOptions" [orderType]="'pickup'" [homersLayout]="homersLayout"></store-checkout-total>
            @if (homersLayout) {
              <div class="checkout-division-homers">
                <app-cartsub-modal class="checkout-btn-homers" [store]="store" [subTotal]="pickupSubTotal" [orderType]="'pickup'" [fromDesktop]="fromDesktop" [homersLayout]="homersLayout"></app-cartsub-modal>
              </div>
            } @else {
              <div class="checkout-division">
                <nav class="checkout-bar">
                  <ul class="navbar-items">
                    <li class="itemBarPlacement">
                      <ion-icon (click)="cancel()" class="checkoutImg" name="cart-outline"></ion-icon>
                    </li>
                    <li class="itemBarPlacement">
                      <p class="textLayout">{{'General.ReadyFor' | translate}} {{readyTime}}</p>
                    </li>
                    <li class="itemBarPlacement">
                      <app-cartsub-modal class="checkout-btn" [store]="store" [subTotal]="pickupSubTotal" [orderType]="'pickup'" [fromDesktop]="fromDesktop"></app-cartsub-modal>
                    </li>
                  </ul>
                </nav>
              </div>
            }
            

          </div>
        </ion-content>
      }
    </ion-content>
  }
}

          
